import React from 'react';
import proptypes from 'prop-types';
const { oneOf, oneOfType, string, bool, node } = proptypes;
import { Typography, Popover, Button, useBreakpoint } from '@one-thd/sui-atomic-components';
import { useHeaderObserver } from '@thd-olt-functional/utils';
import { Delivery, Subscription, Savings } from '@one-thd/sui-icons';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import classNames from 'classnames';
import './message.scss';

const Message = ({
  channel, discount, disabled, linkText, messageText, className
}) => {

  const messageStyles = classNames(className, 'subscribe-and-save-message');
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [entry] = useHeaderObserver();
  const { lesser } = useBreakpoint('sm');

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'subscribe-and-save-message__learn-more' : undefined;

  const popoverContent = (
    <>
      <div className="sui-grid sui-grid-cols-12 sui-pb-4">
        <div className="sui-col-span-1">
          <Delivery className="sui-pr-2" size="large" />
        </div>
        <div className="sui-col-span-11">
          <Typography>
            {discount}% off subscription purchases plus free delivery
          </Typography>
        </div>
        <div className="sui-col-span-1 sui-pt-2">
          <Subscription className="sui-pr-2" size="large" />
        </div>
        <div className="sui-col-span-11 sui-pt-2">
          <Typography>
            Pause or cancel your subscription anytime online
          </Typography>
        </div>
        <div className="sui-col-span-1 sui-pt-2">
          <Savings className="sui-pr-2" size="large" />
        </div>
        <div className="sui-col-span-11 sui-pt-2">
          <Typography>
            No club or membership fees required
          </Typography>
        </div>
      </div>
      <Typography height="normal">
        {'Subscribe to this product today to receive free delivery directly to your doorstep at your convenience. '
          + 'Just select your preferred delivery frequency from the drop down menu '
          + 'and checkout to start your subscription.'}
      </Typography>
      {/* eslint-disable max-len */}
      <div className="sui-pt-4">
        <div className="sui-bg-subtle">
          <ul className="sui-list-disc sui-list-outside sui-ml-8 sui-mr-2 sui-leading-normal sui-text-base">
            <li className="sui-pt-2">You&apos;ll be charged the cost of the item at a <span className="sui-font-bold">{discount}% discount</span> (plus applicable taxes) on the day of each scheduled order.</li>
            <li>You have until the day before the item is ordered to cancel.</li>
            <li className="sui-pb-2">You can cancel by visiting the subscriptions page on your Account Dashboard.</li>
          </ul>
        </div>
      </div>
      {/* eslint-enable max-len */}
    </>
  );

  return disabled
    ? (
      <div
        className="subscribe-and-save-message subscribe-and-save-message--disabled"
        data-component="SubscribeAndSaveMessage"
      >
        <span>Available for Delivery only.</span>
      </div>
    )
    : (
      <div className={messageStyles} data-component="SubscribeAndSaveMessage">
        {messageText
          && <span>{messageText}</span>}
        <Button
          type="button"
          className="u__default-link subscribe-and-save-message__learn-more scrollTouch"
          id="subscribe-and-save-message__learn-more"
          onClick={handleClick}
          variant="text"
        >
          {linkText}
        </Button>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          placement="bottom"
          title="Subscribe"
          disablePortal
          data-testid="subscribe-and-save-popover"
          className="sui-z-tooltip"
        >
          <div
            className="popover-content"
          >
            {popoverContent}
          </div>
        </Popover>
      </div>
    );
};

Message.displayName = 'SubscribeAndSave-Message';

Message.propTypes = {
  channel: oneOf(['mobile', 'desktop']),
  className: string,
  discount: string,
  disabled: bool,
  linkText: oneOfType([node, string]),
  messageText: oneOfType([node, string])
};

Message.defaultProps = {
  channel: 'desktop',
  className: null,
  discount: '5',
  disabled: false,
  linkText: 'Learn More',
  messageText: 'Schedule your product to be delivered for free when you need it most. '
};

export { Message };
